module.exports = __webpack_public_path__ + "static/img/010.39e6551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/010.png
// module id = UwcI
// module chunks = 1